import React from "react";

import FilterStringProto from "../lib/string-proto";

export default class FilterField2String extends FilterStringProto {

    constructor(filtersManager, field, initValue) {
        super(filtersManager, field, initValue, field.label);

        // this.filterConfig is field2 object

        this.field = this.filterConfig.fieldId;
        this.isCustomField = this.filterConfig.isCustom;
    }

    filterFunc(dataItem) {
        if (!this.value) return true;
        const value = dataItem[this.filterConfig.fieldId];
        if (!value) return false;
        return gd.utils.search(value, this.value);
    }

    filterFuncUniversal(dataItem) {return this.filterFunc(dataItem)}
}